module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/business-1.webp";